import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { queryClient } from 'react-query';
import { BrowserRouter } from 'react-router-dom';

import ErrorBoundary, { ErrorFallback } from 'components/ErrorBoundary';
import { AuthProvider } from 'providers';
import Routes from 'router/components/Routes/Routes';
import routes from 'router/routes';
import { ScrollRestoration } from 'ScrollRestoration';

function App() {
  return (
    <ErrorBoundary fallback={ErrorFallback}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BrowserRouter>
            <ScrollRestoration />
            <Toaster position="top-center" toastOptions={{ duration: 2500 }} />

            <Routes routes={routes} />
          </BrowserRouter>
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
